import { TbCheck } from "react-icons/tb";

// "OrangeCheck" — 18px disc with the orange glow, 12px tick inside.
export const OrangeCheck = () => (
  <span className="flex size-[18px] shrink-0 items-center justify-center rounded-full text-[#f59603] drop-shadow-[0px_4px_5px_rgba(245,147,1,0.3)]">
    <TbCheck size={12} strokeWidth={3} />
  </span>
);

// "Feature" — tick vertically centred against the (possibly two-line) copy.
const FeatureRow = ({ children, testId }: { children: React.ReactNode; testId?: string }) => (
  <div data-testid={testId} className="flex w-full items-center gap-[12px]">
    <OrangeCheck />
    <div className="min-w-0 flex-1 text-[13px] leading-[18px] text-[#08080a]">{children}</div>
  </div>
);

export default FeatureRow;
